"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderStreetMap = void 0;
var React = require("react");
var myokay_map2_1 = require("@okay/myokay-map2");
exports.renderStreetMap = function (lat, lng) {
    var center = {
        lat: lat,
        lng: lng,
    };
    var hasLatLng = center.lat && center.lng;
    return hasLatLng ? (React.createElement(myokay_map2_1.GoogleStreetView, { center: center })) : null;
};
